import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    width: 100vw;
    max-height: 90vh;
    overflow: auto;

    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(3)};
    padding: ${theme.layout.spacing(3)};

    border-radius: 16px 16px 0 0;
    background: ${theme.palette.neutral[50]};
    box-shadow: ${theme.layout.shadows.popup};

    header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: ${theme.layout.spacing(2)};

      h2 {
        color: ${theme.palette.text.main};
        font-size: ${theme.typography.sizes.title3};
        font-weight: ${theme.typography.weight.bold};
        line-height: 1.3;
      }

      button {
        flex-shrink: 0;
        width: ${theme.layout.spacing(4.5)};
        height: ${theme.layout.spacing(4.5)};

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 12px;
        border: 1px solid ${theme.palette.neutral[200]};
        background-color: transparent;
        color: ${theme.palette.text.main};
        font-size: ${theme.typography.sizes.title3};
        cursor: pointer;
      }
    }

    form {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(2)};

      label[for='terms'] {
        font-size: ${theme.typography.sizes.caption};
      }

      a {
        color: ${theme.palette.primary.main};
        text-decoration: underline;
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      width: ${theme.layout.spacing(60)};
      border-radius: 16px;
    }
  `}
`;

export const Feedback = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.layout.spacing(2)};
    padding: ${theme.layout.spacing(1, 0)};
    text-align: center;

    h3 {
      color: ${theme.palette.primary.dark};
      font-size: ${theme.typography.sizes.subtitle};
      font-weight: ${theme.typography.weight.bold};
    }

    p {
      color: ${theme.palette.text.light};
      font-size: ${theme.typography.sizes.body1};
      font-weight: ${theme.typography.weight.regular};
    }

    button {
      width: 100%;
    }
  `}
`;
